import { useState } from "react";
import useSearchPagination from "../../../../ReusableComponents/SearchPagination/useSearchPagination";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { setAppError } from "../../../../store/userSlice";
import nodeinstance from "../../../../nodeInstance";
import UploadInsurancePopUp from "./uploadInsurance_PopUp";

export default function AppliedList({
  titles,
  trigger,
  setTrigger,
  dependentDetails,
}) {
  const token = localStorage.getItem("nodeToken");
  //   const dispatch = useDispatch();
  console.log("trigger......My Circle", trigger);

  const [excelPopUp, setExcelPopUp] = useState(false);

  const handle = () => {
    setExcelPopUp(true)
  }

  const [searchWords, setSearchWords] = useState([]);
  const {
    NoDataFound,
    Pagination,
    PaginationIndex,
    Search,
    CountPerPage,
    currentList,
  } = useSearchPagination(dependentDetails?.data || []);
  const [downloadLoading, setDownloadLoading] = useState(false);
  const dispatch = useDispatch();
  const downloadFile = async () => {
    setDownloadLoading(true);
    try {
      const response = await nodeinstance.get(
        `/insurance-dependent/AppliedListReport`,
        {
          responseType: "blob",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status === 200) {
        const url = window.URL.createObjectURL(response.data);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `Insurance_OPS2_upload_template`);
        document.body.appendChild(link);
        link.click();
        dispatch(
          setAppError({
            msg: "Excel Downloaded",
            color: "success",
          })
        );
        setDownloadLoading(false);
      } else {
        throw new Error("Something went wrong!");
      }
    } catch (err) {
      setDownloadLoading(false);
      dispatch(
        setAppError({
          msg: err.message,
        })
      );
    }
  };
  console.log("currentList.....print", currentList);
  return (
    <>
      <div className="flex justify-between items-center gap-x-4 mt-4">
        {/* Left side content */}
        <div className="flex gap-x-4">
          <Search
            searchKey={["DEPENDENT_NAME", "DEPENDENT_IQAMA_NUMBER"]}
            setSearchWords={setSearchWords}
          />
          <button
            className="bg-black text-white px-4 rounded-md py-2 text-sm h-[36px]"
            // onClick={() => downloadFile()}
          >
            DOWNLOAD
          </button>
        </div>

        {/* Right side buttons */}
        <div className="flex gap-x-4">
          <button
            className="bg-black text-white px-4 rounded-md py-2 text-sm h-[36px]"
            onClick={() => {
              downloadFile();
            }}
          >
            Download INSURANCE DATA TEMPLATE
          </button>
          <button
            className="bg-black text-white px-4 rounded-md py-2 text-sm h-[36px]"
            onClick={() => {
              handle();
            }}
          >
            UPLOAD INSURANCE DATA
          </button>
        </div>
      </div>
      <div
        className="overflow-x-auto mt-5"
        style={{ backgroundColor: "white" }}
      >
        <table className="min-w-full divide-gray-200">
          <thead className="bg-gray-100">
            <tr>
              {titles.map((columnName, index) => (
                <th
                  key={index}
                  scope="col"
                  className="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider font-semibold"
                >
                  {columnName}
                </th>
              ))}
            </tr>
          </thead>
          <tbody className="bg-white divide-gray-10">
            {currentList?.map((listItem, index) => (
              <tr key={index}>
                <td className="px-6 py-4 whitespace-nowrap">{index + 1}</td>
                <td className="px-6 py-4 whitespace-nowrap">
                  {listItem?.DEPENDENT_NAME}
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  {/* {listItem?.DATE_OF_BIRTH ? listItem?.DATE_OF_BIRTH : "------"} */}
                  {listItem?.DATE_OF_BIRTH
                    ? new Date(listItem?.DATE_OF_BIRTH)
                        .toLocaleDateString("en-GB", {
                          day: "2-digit",
                          month: "short",
                          year: "numeric",
                        })
                        .split(" ")
                        .join("-")
                        .toUpperCase()
                    : "-----"}
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  {listItem.DEPENDENT_IQAMA_NUMBER}
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  {listItem?.RELATION}
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  {listItem?.CLASS}
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  {listItem.GENDER}
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  {listItem?.HEAD_OF_FAMILY}
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  {/* {listItem.INSURANCE_APPLY_DATE} */}
                  {listItem.INSURANCE_APPLY_DATE
                    ? new Date(listItem.INSURANCE_APPLY_DATE)
                        .toLocaleDateString("en-GB", {
                          day: "2-digit",
                          month: "short",
                          year: "numeric",
                        })
                        .split(" ")
                        .join("-")
                        .toUpperCase()
                    : "-----"}
                  </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  {listItem?.DELAYED_DAYS}
                </td>
                <td className="px-6 py-4 whitespace-nowrap">{""}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <Pagination />
      {excelPopUp ? (
        <UploadInsurancePopUp
          excelPopUp={excelPopUp}
          setExcelPopUp={setExcelPopUp}
          setTrigger={setTrigger}
          trigger={trigger}
        />
      ) : (
        ""
      )}
    </>
  );
}
